export enum BUSINESS_CATEGORY_STEPS {
    LIST_CATEGORIES = 1,
    EDIT_ADD_CATEGORY = 2,
}

export interface AssociatedBusinessTypes {
    businessCategoryName: string;
    businessTypeId: number;
    name: string;
}

export interface BusinessTypesModal {
    associatedBusinessTypes: AssociatedBusinessTypes[];
    storeFrontImageReference: string;
}
